var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{'card greenCard': _vm.makeGreen, 'card redCard': !_vm.makeGreen}},[_c('apexchart',{staticClass:"minichart",attrs:{"id":"chart","type":"candlestick","options":_vm.chartOptions,"series":_vm.series,"align":"center"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }